import React, { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

const Modal = ({ handleClose, content, header }) => {


  return (
    <div className='modal-box'>
      <div className='modal-box-1'>
        <div className='modal-box-2'>
                <div className='modal-box-3'>{header}</div>
                <div onClick={()=>handleClose()}><CloseIcon sx={{fontSize:"3rem"}} /></div>
        </div>
        <div className='modal-box-4'>
                 {content}
        </div>
      </div>
    </div>
  )
}

export default Modal
